import { createFileRoute } from "@tanstack/react-router";
import BrandPage from "@/pages/BrandPage";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/product-east-to-west/")({
  head: () => pageHead({ title: 'East to West RVs', description: 'Shop East to West RVs at Rex & Sons RVs in Castle Hayne, NC.', path: '/product-east-to-west' }),
  component: BrandPage,
});